<template>
  <div>
    <Nav />
    <div class="register-confirm">
      <div id="content">
        <div class="register">
          <div class="wrapper">
            <div class="inner">
              <div class="main">
                <h1 class="main-title">Confirmation</h1>
                <div class="ui form">
                  <p class="required-text">
                    <span>*</span>Required information
                  </p>
                  <div class="register-confirmation">
                    <ul class="list">
                      <li class="field required">
                        <label>Name</label>
                        <div class="two-fields">
                          <div class="field">
                            <p class="data">UserName</p>
                          </div>
                          <div class="field">
                            <p class="data">LastName</p>
                          </div>
                        </div>
                      </li>
                      <li class="field required">
                        <label>Email</label>
                        <p class="data">email@example.com</p>
                      </li>
                      <li class="field">
                        <label>LinkedIn URL</label>
                        <p class="data">
                          https://www.linkedin.com/in/userlinkedinaccount
                        </p>
                      </li>
                      <li class="field">
                        <label>LINE ID</label>
                        <p class="data">UserLINEId</p>
                      </li>
                      <li class="field">
                        <label>Phone No.</label>
                        <p class="data">09 1234 5678</p>
                      </li>
                      <li class="field required">
                        <label>How long have you been a recruiter?</label>
                        <p class="data">3-5 Years</p>
                      </li>
                      <li class="field required">
                        <label
                          >Which industry are you specialized in?
                          <span class="field-note"
                            >(Can select more than 1)</span
                          ></label
                        >
                        <ul class="checkbox-data">
                          <li>
                            <p class="data">Information Technology</p>
                          </li>
                          <p class="data">Web / Mobile / Game</p>
                        </ul>
                      </li>
                      <li class="field required">
                        <label
                          >What kind of positions are you specialized in?</label
                        >
                        <p class="data">
                          UX Researcher, Web Developer, Full Stack Developer
                        </p>
                      </li>
                      <li class="field required">
                        <label>Which agency have you worked at?</label>
                        <p class="data">ABCD Recruitment Co.,Ltd.</p>
                      </li>
                      <li class="field upload-button">
                        <label>CV Upload</label>
                        <p class="data">
                          <i class="las la-paperclip"></i>ABCD Recruitment
                          Co.,Ltd.
                        </p>
                      </li>
                      <li class="submit-button">
                        <button class="btn btn-outline" type="submit">
                          Back
                        </button>
                        <button class="btn btn-blue" type="submit">
                          Confirm
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import Nav from "@/components/layouts/Nav";
import Footer from "@/components/layouts/Footer";
export default {
  name: "RegisterConfirm",
  components: {
    Nav,
    Footer,
  },
};
</script>
<style scoped lang="scss">
@import "~@/assets/stylesheets/application";
@import "~@/assets/stylesheets/register";
.register-confirmation {
  p.data {
    font-size: 1.2em;
    font-weight: 500;
    padding: 0;
  }

  .field {
    label {
      /* stylelint-disable-next-line declaration-no-important */
      color: #999 !important;
    }

    .two-fields {
      display: flex;
      justify-content: flex-start;

      .field {
        margin-right: 1rem;
        width: auto;
      }
    }

    .checkbox-data {
      display: flex;
      flex-direction: column;

      li {
        margin-bottom: 0.5rem;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }

  .upload-button {
    .data {
      i {
        color: $gray;
        font-size: 20px;
        margin-right: 5px;
      }
    }
  }

  .submit-button {
    align-items: center;
    display: flex;
    /* stylelint-disable-next-line declaration-no-important */
    flex-direction: row !important;
    justify-content: center;

    .btn {
      /* stylelint-disable-next-line declaration-no-important */
      margin: 0 1rem !important;
      width: 150px;
    }

    .btn-outline {
      border-color: $gray;
      color: $gray;
    }
  }
}
@media only screen and (max-width: 991px) {
  .register-confirmation {
    p.data {
      font-size: 1em;
    }

    .field {
      /* stylelint-disable-next-line declaration-no-important */
      margin-bottom: 1rem !important;

      label {
        /* stylelint-disable-next-line declaration-no-important */
        margin-bottom: 0 !important;
      }

      .two-fields {
        display: flex;
        justify-content: flex-start;

        .field {
          /* stylelint-disable-next-line declaration-no-important */
          margin-bottom: 0 !important;
          margin-right: 1rem;
          width: auto;
        }
      }

      .checkbox-data {
        display: flex;
        flex-direction: column;

        li {
          margin-bottom: 0.5rem;

          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }
  }
}
</style>
